import { render, staticRenderFns } from "./SentimentIndexMiniCards.vue?vue&type=template&id=9b34e080&scoped=true"
import script from "./SentimentIndexMiniCards.vue?vue&type=script&lang=js"
export * from "./SentimentIndexMiniCards.vue?vue&type=script&lang=js"
import style0 from "./SentimentIndexMiniCards.vue?vue&type=style&index=0&id=9b34e080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34e080",
  null
  
)

export default component.exports